import '@src/index.css';
import App from '@src/App';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

const init = () => {
  const appContainer = document.querySelector('#app-container');
  if (!appContainer) {
    throw new Error('Can not find #app-container');
  }
  const root = createRoot(appContainer);
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
  );
};

init();
